import React from 'react';

import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import { getImageUrl } from 'components/modules/files/services/files';
import { BusinessFilePropType } from 'components/modules/files/types/files';

import Dots from '../../../../../../common/sortables/Dots';

import './DeckItem.scss';

const propTypes = {
  file: BusinessFilePropType.isRequired,
  onFileEdit: PropTypes.func,
};

const defaultProps = {
  onFileEdit: null,
};

export default function DeckItem({ file, onFileEdit }) {
  const imageUrl = getImageUrl(file, { params: { width: 200 } });
  const style = {
    backgroundImage: `url(${imageUrl})`,
  };

  return (
    <div className="deck-item" style={style}>
      <Dots size="5px" />
      {onFileEdit && <Icon name="on-edit pencil" onClick={onFileEdit} />}
    </div>
  );
}

DeckItem.propTypes = propTypes;
DeckItem.defaultProps = defaultProps;
